export type CheckinFunctionIdType = (typeof CheckinFunctionIdType)[keyof typeof CheckinFunctionIdType];
export const CheckinFunctionIdType = {
  CHECKIN: 'C01',
  BOARDING_PROCEDURES: 'C02',
  NUMBER_OF_WAITING_CONFIRMATION: 'C03',
} as const;
